<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>课程配置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="资源名称">
          <el-input v-model="listQuery.fileName" placeholder clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            v-per="'addCourse'"
            class="el-icon-plus"
            plan
            @click="addCourse"
          >新增资源</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column prop="fileOssId" label="资源id"></el-table-column>
        <el-table-column prop="fileName" label="资源名称"></el-table-column>
        <el-table-column prop="fileUrl" label="资源地址"></el-table-column>
        <el-table-column prop="fileType" label="资源类型">
          <template slot-scope="scope">
            <span>{{fileType[scope.row.fileType] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="duration" label="时长">
                      <template slot-scope="scope">
            <span>{{formatDuration(scope.row.duration) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>

        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
          
          
            <el-button
              type="text"
              :disabled="scope.row.deleted==1"
              icon="el-icon-delete"
              @click="handleDel(scope.$index, scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        :total="total"
        :page.sync="currentPage"
        :limit.sync="pageSize"
        @pagination="querySearch"
      />
    </el-card>

    <el-dialog
      title="添加课程资源"
      :visible.sync="showAdd"
      width="500px"
      :close-on-click-modal="false"
      center
    >

        <input type="file" id="fileUpload" @change="fileChange($event)"  ref="fileInput"/>
        <label class="status">
          上传状态:
          <span>{{statusText}}</span>
        </label>
        <div style="margin-top:20px;">
            <div>
                 <el-form ref="addForm" :model="addForm" :rules="addRules" label-width="100px">
                               <el-form-item label="资源名称" prop="fileName">
              <el-input clearable v-model="addForm.fileName" placeholder="请输入文件名称"></el-input>
            </el-form-item>
                 </el-form>
            </div>
          <el-button @click="authUpload" :disabled="uploadDisabled">开始上传</el-button>
          <span class="progress">
            上传进度:
            <i id="auth-progress">{{authProgress}}</i> %
          </span>
        </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false">关闭</el-button>
        <el-button type="primary" @click="saveResource()">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
  components: { Pagination },
  data() {
    return {
       
        fileOssId:'',
        fileName:'',
      fileType: {
        0: "",
        1: "图片",
        2: "视频"
      },
      file: null,
      authProgress: 0,
      uploadDisabled: true,
      resumeDisabled: true,
      pauseDisabled: true,
      uploader: null,
      statusText: "",
      sdkReady: false,
      listData: [],

      skillList: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        fileName: ""
      },
    addForm:{
        fileName:''
    },
   
    addRules: {
        fileName: [
          {
            required: true,
            message: "请输入文件名称",
            trigger: "blur"
          }
        ],
       
      },
      showUpdate: false,
      showAdd: false
    };
  },

  created() {
    this.querySearch();
    this.loadAliyunSDK();
  },
 
  methods: {
    loadAliyunSDK() {
      if (window.AliyunUpload) {
        this.sdkReady = true;
        return;
      }
      const scripts = [
        'static/lib/aliyun-upload-sdk/lib/es6-promise.min.js',
        'static/lib/aliyun-upload-sdk/lib/aliyun-oss-sdk-6.17.1.min.js',
        'static/lib/aliyun-upload-sdk/aliyun-upload-sdk-1.5.4.min.js'
      ];
      const loadNext = (i) => {
        if (i >= scripts.length) { this.sdkReady = true; return; }
        const s = document.createElement('script');
        s.src = scripts[i];
        s.onload = () => loadNext(i + 1);
        s.onerror = () => console.error('Failed to load: ' + scripts[i]);
        document.body.appendChild(s);
      };
      loadNext(0);
    },
    formatDuration(value){
     if(value==''){
       return '';
     }else{
      var hour=Math.floor(value/3600);
      var minute=Math.floor((value-hour*3600)/60);
      var second=value%60;
      return hour+'小时'+minute+'分钟'+second+'秒';
    //   return hour+'小时'+minute+'分钟';
     }
 
},
    fileChange(e) {
      this.file = e.target.files[0];
      if (!this.file) {
        alert("请先选择需要上传的文件!");
        return;
      }
      if (!this.sdkReady || !window.AliyunUpload) {
        alert("上传SDK正在加载，请稍后重试");
        return;
      }
      var Title = this.file.name;
      this.fileName=Title;
      this.addForm.fileName=Title;
      var userData = {Title:Title};
      if (this.uploader) {
        this.uploader.stopUpload();
        this.authProgress = 0;
        this.statusText = "";
      }
      this.uploader = this.createUploader();
      console.log(userData);
      this.uploader.addFile(this.file, null, null, null, JSON.stringify(userData));
      this.uploadDisabled = false;
      this.pauseDisabled = true;
      this.resumeDisabled = true;
    },
    authUpload() {
      // 然后调用 startUpload 方法, 开始上传
      if (this.uploader !== null) {
        this.uploader.startUpload();
        this.uploadDisabled = true;
        this.pauseDisabled = false;
      }
    },
    createUploader(type) {
      let self = this;
      let uploader = new AliyunUpload.Vod({
        timeout: self.timeout || 60000,
        partSize: Math.round(self.partSize || 1048576),
        parallel: self.parallel || 5,
        retryCount: self.retryCount || 3,
        retryDuration: self.retryDuration || 2,
        region: "cn-shanghai",
        userId: '1348347433486318',
        //  region: 'cn-beijing',
        // userId: '1111',
        // 添加文件成功
        addFileSuccess: function(uploadInfo) {
          self.uploadDisabled = false;
          self.resumeDisabled = false;
          self.statusText = "添加文件成功, 等待上传...";
          console.log("addFileSuccess: " + uploadInfo.file.name);
        },
        // 开始上传
        onUploadstarted: function(uploadInfo) {
          // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
          // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
          // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
          // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
          // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
          // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
          console.log(uploadInfo);
         if (!uploadInfo.videoId) {
               console.log('create');
             
            // let createUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/CreateUploadVideo?Title=testvod1&FileName=aa.mp4&BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&VideoId=5bfcc7864fc14b96972842172207c9e6'
            //   axios.get(createUrl).then(({data}) => {
            //     let uploadAuth = data.UploadAuth
            //     let uploadAddress = data.UploadAddress
            //     let videoId = data.VideoId
            //     uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)                
            //   })
             crmApi.$axiosFileCreate({fileType:'2'}).then(({ data }) => {
              let uploadAuth = data.data.uploadAuth;
              let uploadAddress = data.data.uploadAddress;
              let videoId = data.data.fileOssId;
              self.fileOssId=videoId;
;
              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress,
                videoId
              );
            });
            self.statusText = "文件开始上传...";
            console.log(
              "onUploadStarted:" +
                uploadInfo.file.name +
                ", endpoint:" +
                uploadInfo.endpoint +
                ", bucket:" +
                uploadInfo.bucket +
                ", object:" +
                uploadInfo.object
            );
          } else {
              console.log('refresh');
            // 如果videoId有值，根据videoId刷新上传凭证
            // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
            let refreshUrl =
              "https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=" +
              uploadInfo.videoId;
            axios.get(crmApi.fileCreateUrl).then(({ data }) => {
              let uploadAuth = data.UploadAuth;
              let uploadAddress = data.UploadAddress;
              let videoId = data.VideoId;
              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress,
                videoId
              );
            });
          }
        },
        // 文件上传成功
        onUploadSucceed: function(uploadInfo) {
          console.log(
            "onUploadSucceed: " +
              uploadInfo.file.name +
              ", endpoint:" +
              uploadInfo.endpoint +
              ", bucket:" +
              uploadInfo.bucket +
              ", object:" +
              uploadInfo.object
          );
          self.statusText = "文件上传成功!";
        },
        // 文件上传失败
        onUploadFailed: function(uploadInfo, code, message) {
          console.log(
            "onUploadFailed: file:" +
              uploadInfo.file.name +
              ",code:" +
              code +
              ", message:" +
              message
          );
          self.statusText = "文件上传失败!";
        },
        // 取消文件上传
        onUploadCanceled: function(uploadInfo, code, message) {
          console.log(
            "Canceled file: " +
              uploadInfo.file.name +
              ", code: " +
              code +
              ", message:" +
              message
          );
          self.statusText = "文件已暂停上传";
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function(uploadInfo, totalSize, progress) {
          console.log(
            "onUploadProgress:file:" +
              uploadInfo.file.name +
              ", fileSize:" +
              totalSize +
              ", percent:" +
              Math.ceil(progress * 100) +
              "%"
          );
          let progressPercent = Math.ceil(progress * 100);
          self.authProgress = progressPercent;
          self.statusText = "文件上传中...";
        },
        // 上传凭证超时
        onUploadTokenExpired: function(uploadInfo) {
          // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
          // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
          // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
          let refreshUrl =
            "https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=" +
            uploadInfo.videoId;
          axios.get(refreshUrl).then(({ data }) => {
            let uploadAuth = data.UploadAuth;
            uploader.resumeUploadWithAuth(uploadAuth);
            console.log(
              "upload expired and resume upload with uploadauth " + uploadAuth
            );
          });
          self.statusText = "文件超时...";
        },
        // 全部文件上传结束
        onUploadEnd: function(uploadInfo) {
          console.log("onUploadEnd: uploaded all the files");
          self.statusText = "文件上传完毕";
        }
      });
      return uploader;
    },
    handleDel(index, row) {
      this.$confirm("是否删除该资源?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          crmApi
            .$axiosFileDelete({
              fileOssId: row.fileOssId,
            //   updateUserId: globalData.userInfo.id
            })
            .then(res => {
              if (res.data.errno == 0) {
                this.$message.success("操作成功");
                this.querySearch();
              }
            });
        })
        .catch(() => {});
    },
   
    addCourse() {
        if(this.$refs.fileInput){
this.$refs.fileInput.value='';
        }
      this.showAdd = true;
      this.file=null;
      this.statusText='';
      this.authProgress=0;
      
    
    },

    saveResource() {
        if(!this.file){
              this.$message.error("请先选择文件");
              return false;
              
        }else if(this.fileOssId==''||this.fileName==''||this.authProgress!=100){
              this.$message.error("请先上传文件");
              return false;
        }
        this.$refs["addForm"].validate(valid => {
        if (valid) {
          crmApi.$axiosSyncUploadInfo({ fileOssId:this.fileOssId,
        fileName:this.addForm.fileName,}).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("操作成功");
              this.showAdd = false;
              this.querySearch();
            } else {
              this.$message.error(res.data.data);
            }
          });

        }
        });
      
    },

    //查询
    querySearch() {
      this.listQuery.pageSize = this.pageSize;
      this.listQuery.pageNum = this.currentPage;
      crmApi.$axiosFileossList(this.listQuery).then(res => {
        if (res.data.errno == 0) {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        }
      });
    },
    getAllSkill() {
      crmApi.$ajaxEmCourseGetAllSkillDict().then(res => {
        if (res.data.errno == 0) {
          this.skillList = res.data.data;
        }
      });
    }
  },
  beforeCreate() {
    vm = this;
  }
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}
.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
</style>